import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';

const routes = {
  filter: '/contract-employment/appendix/list',
  addContractAppendix: '/contract-employment/personal/add-contract-appendix'
};

export interface AppendixFilterRequest {
  employeeEnterpriseId: string;
  nameOrCode: string;
}

export interface AppendixFilterRow {
  id: string;
  contractName: string;
  contractCode: string;
  signedDate?: string;
}

export interface AppendixFilterResponse {
  success?: boolean;
  message?: string;
  dataRow: AppendixFilterRow[];
}

export interface AddContractAppendixRequest {
  contractOriginalId: string;
  contractAppendixId: string[];
}

export interface AddContractAppendixResponse {
  code: string;
  message: string;
  success: boolean;
}

@Injectable({ providedIn: 'root' })
export class LinkDocumentAppendixService {
  constructor(private apiService: ApiService) {}

  filter(request: AppendixFilterRequest): Observable<any> {
    return this.apiService.post(routes.filter, request);
  }

  addContractAppendix(request: AddContractAppendixRequest): Observable<AddContractAppendixResponse> {
    return this.apiService.post(routes.addContractAppendix, request);
  }
}
